import React from "react";
import { personalInfo } from "../data/portfolioData";

const Resume: React.FC = () => {
  const handleDownload = () => {
    // This will trigger a download when you add your actual resume file
    if (personalInfo.resumeUrl) {
      const link = document.createElement("a");
      link.href = personalInfo.resumeUrl;
      link.download = "Spurthi_Setty_Resume.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Fallback - you can replace this with your actual resume URL
      alert(
        "Please add your resume file to the public folder and update the resumeUrl in portfolioData.ts"
      );
    }
  };

  return (
    <section id="resume" className="section-padding">
      <div className="container-max">
        <div className="text-center">
          <h2 className="section-title">Resume</h2>
          <p className="section-subtitle mb-12">
            Download my complete resume to learn more about my experience,
            skills, and achievements
          </p>

          <div className="card max-w-4xl mx-auto">
            <div className="space-y-8">
              {/* Resume Preview */}
              <div className="text-left">
                <h3 className="text-2xl font-bold text-white mb-6">
                  Resume Preview
                </h3>

                <div className="space-y-6">
                  {/* Contact Info */}
                  <div className="border-b border-dark-600 pb-6">
                    <h4 className="font-semibold text-white mb-3 text-lg">
                      Contact Information
                    </h4>
                    <p className="text-dark-300">{personalInfo.name}</p>
                    <p className="text-dark-300">{personalInfo.location}</p>
                    <p className="text-dark-300">{personalInfo.email}</p>
                  </div>

                  {/* Education */}
                  <div className="border-b border-dark-600 pb-6">
                    <h4 className="font-semibold text-white mb-3 text-lg">
                      Education
                    </h4>
                    <p className="text-dark-300">{personalInfo.education}</p>
                  </div>

                  {/* Skills */}
                  <div className="border-b border-dark-600 pb-6">
                    <h4 className="font-semibold text-white mb-3 text-lg">
                      Key Skills
                    </h4>
                    <div className="flex flex-wrap gap-3">
                      {personalInfo.skills.slice(0, 8).map((skill, index) => (
                        <span key={index} className="tech-tag">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Experience Summary */}
                  <div>
                    <h4 className="font-semibold text-white mb-3 text-lg">
                      Experience Summary
                    </h4>
                    <ul className="text-dark-300 space-y-2 text-lg">
                      <li className="flex items-center">
                        <span className="text-primary-400 mr-3">•</span>
                        ML Engineer Intern at GlobalFoundries
                      </li>
                      <li className="flex items-center">
                        <span className="text-primary-400 mr-3">•</span>
                        Computer Vision Lead at Anote.ai
                      </li>
                      <li className="flex items-center">
                        <span className="text-primary-400 mr-3">•</span>
                        Software Engineer Intern at Medtronic
                      </li>
                      <li className="flex items-center">
                        <span className="text-primary-400 mr-3">•</span>
                        Quantitative Analyst at Stevens SMIF
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Download Button */}
              <div className="pt-8">
                <button
                  onClick={handleDownload}
                  className="btn-primary inline-flex items-center text-xl px-10 py-4"
                >
                  <svg
                    className="w-6 h-6 mr-3"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Download Resume (PDF)
                </button>
              </div>

              {/* Note */}
              <p className="text-sm text-dark-400 text-center">
                * Please add your actual resume PDF file to the public folder
                and update the resumeUrl in portfolioData.ts
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
